<template>
	<transition name="fade-slide-right">
		<nav class="mobile-menu" v-if="widgets.mobileMenu">
			<div class="mobile-menu__container">
				<a class="mobile-menu__close is-large" @click="hideMobileMenu"></a>
				<app-menu
					className="mobile-menu__list"
					v-on:scrollingStart="hideMobileMenu"
				/>
			</div>
		</nav>
	</transition>
</template>

<script>
	import { mapState, mapActions } from 'vuex'

	import brandingMixin from '@/mixins/branding'
	import Menu from '@/components/menu/menu.vue'

	export default {
		mixins: [brandingMixin],
		components: {
			appMenu: Menu
		},
		computed: {
			...mapState('utils', ['widgets'])
		},
		methods: {
			...mapActions('utils', ['setVisibleMobileMenu']),
			hideMobileMenu () {
				this.setVisibleMobileMenu(false)
			}
		},
		watch: {
			$route () {
				setTimeout(() => {
					this.hideMobileMenu()
				}, 350)
			}
		}
	}
</script>

<style lang="scss">
	@import "~@/styles/variables";
	@import "~@/styles/mixins";

	.mobile-menu {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9000;
		height: 100%;
		width: 100%;
		overflow-y: auto;
		background-color: var(--color-mobile-menu);

		@include min-screen($media-header-medium) {
			display: none;
		}

		&__container {
			display: flex;
			flex-wrap: wrap;
			padding: 1.25rem;
			text-align: center;
		}

		&__close {
			@include delete();
			margin-left: auto;
			margin-bottom: 0.9375rem;
			border-radius: 0.125rem;
			background-color: var(--color-mobile-menu-close);

			&:hover, &:focus, &:active {
				background-color: var(--color-mobile-menu-close);
			}
		}

		&__list {
			width: 100%;

			a {
				position: relative;
				display: inline-block;
				padding: 0.9375rem;
				text-transform: uppercase;
				line-height: 1;
				letter-spacing: 0.05rem;
				color: var(--color-mobile-menu-link);
				transition: color .3s ease-out;

				&:hover:not(.is-active) {
					color: var(--color-mobile-menu-link);
				}

				&.is-active {
					color: var(--color-mobile-menu-link-active);

					&:before, &:after {
						opacity: 1;
						transform: translate3d(0, 0, 0);
					}
				}

				&:before, &:after {
					content: '';
					position: absolute;
					width: 0.625rem;
					height: 0.625rem;
					border: 0.125rem solid var(--color-mobile-menu-link-active);
					opacity: 0;
					transition: transform .3s, opacity .3s;
					transition-timing-function: cubic-bezier(0.17, 0.67, 0.05, 1.29);
				}

				&:before {
					top: 0;
					left: 0;
					border-width: 0.125rem 0 0 0.125rem;
					transform: translate3d(0.625rem, 0.625rem, 0);
				}

				&:after {
					bottom: 0;
					right: 0;
					border-width: 0 0.125rem 0.125rem 0;
					transform: translate3d(-0.625rem, -0.625rem, 0);
				}
			}
		}
	}
</style>
